import React from 'react';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ErrorBoundary from './utils/Errorboundary';
import AppLayout from './components/Layout/AppLayout';

import HomePage from './page/HomePage/HomePage';
import Product from './page/Product/Product';
import Contact from './page/FooterPages/Contact/Contact';
import AboutUs from './page/FooterPages/AboutUs/AboutUs';
import Careers from './page/FooterPages/Careers/Careers';

import Register from './page/auth/Register';
import Login from './page/auth/Login';
import ForgotPassword from './page/auth/ForgotPassword';
import ResetPassword from './page/auth/ResetPassword';
import ConfirmCode from './page/auth/ConfirmCode';

import SingleSession from './page/RegisterUserPages/SingleSession';

import AdminRoutes from './routes/AdminRoutes';
import AddSession from './page/AdminPages/AddSession';
import EditSessions from './page/AdminPages/EditSessions';
import AllSessions from './page/AdminPages/AllSessions';
import Session from './page/AdminPages/Session';

import EventCalender from './components/EventCalender/EventCalender';
import FilterPage from './page/FilterPage/FilterPage';
import { decryptData } from './utils/encryptData';
import { useSelector } from 'react-redux';
import PrivacyPolicy from './page/FooterPages/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './page/FooterPages/TermsOfService/TermsOfService';
import CookiePolicy from './page/FooterPages/CookiePolicy/Cookie Policy';
import FAQs from './page/FooterPages/FAQs/FAQs';
import TradingResources from './page/FooterPages/TradingResources/Trading Resources';
import Disclaimer from './page/FooterPages/Disclaimer/Disclaimer';
import LegalNotice from './page/FooterPages/LegalNotice/LegalNotice';
import DMCA from './page/FooterPages/DMCA/DMCA';
import NotFoundPage from './page/NotFound/NotFoundPage';
import ComingSoonPage from './page/ComingSoon/ComingSoonPage';
import CookieConsenBar from './components/CookieConsenBar/CookieConsenBar';
import AllUsers from './page/AdminPages/Users/AllUsers';
import MarketAnalysisPage from './page/MarketAnalysisPage/MarketAnalysisPage';
import SingleCollection from './page/AdminPages/Collection/SingleCollection';
import AllCollection from './page/AdminPages/Collection/AllCollection';
import EditerRouters from './routes/EditerRouters';
import AddMarketAnalysis from './page/AdminPages/MarketAnalysis/AddMarketAnalysis.js';
import AllMarketAnalyisi from './page/AdminPages/MarketAnalysis/AllMarketAnalyisi.js';
import EditMarketAnalysis from './page/AdminPages/MarketAnalysis/EditMarketAnalysis.js';
import SingleArticlePage from './page/AdminPages/MarketAnalysis/SingleArticlePage.js';
import Feed from '././page/Community/Feed.js';
import EducationMeterial from './page/EducationMeterial/EducationMeterial.js';
import AllArticle from './page/Community/AllArticle.js';
import Article from './page/Community/Article.js';
import Topics from './page/Community/Topics.js';
import Topic from './page/Community/Topic.js';
import EditProfile from './components/Modal/EditProfile.js';
import TradingSignal from './page/AdminPages/MarketAnalysis/TradingSignal.js';

function App() {
  const { isAuthenticated, rl } = useSelector((state) => state.auth);

  const decryptRole = decryptData(rl);
  return (
    <>
      <BrowserRouter>
        <ErrorBoundary>
          <AppLayout>
            <Routes>
              <Route path="/" element={<HomePage />} />

              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/edit-profile" element={<EditProfile />} />

              {!isAuthenticated && ( //not login
                <>
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                </>
              )}

              {isAuthenticated &&
                (decryptRole === 'admin' || decryptRole === 'user') && (
                  <Route
                    path="/session/video/:id/:type/:filter?"
                    element={<SingleSession />}
                  />
                )}

              <Route path="/single-session" element={<SingleSession />} />
              <Route path="/event/calendar" element={<EventCalender />} />
              <Route path="/session/all" element={<FilterPage />} />
              <Route
                path="community/coming-soon"
                element={<ComingSoonPage />}
              />
              <Route
                path="education/meterial"
                element={<EducationMeterial />}
              />
              <Route
                path="/analysis/market-analysis"
                element={<MarketAnalysisPage />}
              />
              <Route
                path="/analysis/trading-signal"
                element={<TradingSignal />}
              />
              <Route
                path="market-analysis/article/:id"
                element={<SingleArticlePage />}
              />

              {/* Community */}
              <Route path="/community/feed" element={<Feed />} />
              <Route path="/community/articles" element={<AllArticle />} />
              <Route path="/community/articles/:id" element={<Article />} />
              <Route path="/community/topics" element={<Topics />} />
              <Route path="/community/topics/:id" element={<Topic />} />
              <Route path="/community/live" element={<ComingSoonPage />} />

              {/* Footer section routes */}
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/trading-resources" element={<TradingResources />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/legal-notice" element={<LegalNotice />} />
              <Route path="/dmca-notice" element={<DMCA />} />

              {/* Admin-protected routes */}
              <Route path="/admin" element={<AdminRoutes />}>
                <Route path="session/add" element={<AddSession />} />
                <Route path="session/edit/:id" element={<EditSessions />} />
                <Route path="session/all" element={<AllSessions />} />
                <Route path="session/:id" element={<Session />} />
                <Route path="collection/:id" element={<SingleCollection />} />
                <Route path="collection/all" element={<AllCollection />} />

                {/* Users */}
                <Route path="users/all" element={<AllUsers />} />
              </Route>

              <Route path="/admin" element={<EditerRouters />}>
                <Route
                  path="market-analysis/all"
                  element={<AllMarketAnalyisi />}
                />
                <Route
                  path="market-analysis/add"
                  element={<AddMarketAnalysis />}
                />
                <Route
                  path="market-analysis/edit/:id"
                  element={<EditMarketAnalysis />}
                />
              </Route>

              {/* <Route path="*" element={<NotFoundPage />} /> */}
            </Routes>
          </AppLayout>
        </ErrorBoundary>
        <CookieConsenBar />
      </BrowserRouter>
    </>
  );
}

export default App;
